export const CAREER_PAGE_BODY =
  'Please email your resume to info@cashclever.net and someone will get back to you!';
export const CAREER_PHONE = '1-646-780-9673';
// export const CAREER_ADDRESS_1 = '2 University Plaza, Suite 100';
export const CAREER_ADDRESS_1 = '450 Lexington Avenue';
// export const CAREER_ADDRESS_2 = 'Hackensack, NJ 07601';
export const CAREER_ADDRESS_2 = 'New York, NY 10017';
export const CAREER_EMAIL_ADDRESS = 'info@cashclever.net';
export const CAREER_CONTACT_HEADER = 'Submit your resume or contact directly to our team';
export const CAREER_CONTACT_SUBHEADER =
  "We'll get back to you as soon as possible, thank you for your patience!";

export const CAREER_CORE_VALUES_HEADER = 'Our Core Values';
export const CAREER_CORE_VALUES_SUBHEADER =
  'Wherever we go, our values guide us to grow and improve';
export const CAREER_CORE_VALUES_LIST = [
  {
    title: 'Honesty & Transparency',
    body: 'We believe in clear and open communication. Our marketplace operates with full transparency, ensuring that all terms, fees, and processes are straightforward and easy to understand.',
  },
  {
    title: 'Trust & Integrity',
    body: 'Building trust is at the core of our mission. We uphold the highest ethical standards, ensuring that every interaction is grounded in integrity, fairness, and accountability.',
  },
  {
    title: 'Innovation',
    body: 'We embrace technology and data-driven insights to create a smarter and more efficient lending experience. Our commitment to continuous innovation allows us to improve accessibility, security, and ease of use.',
  },
  {
    title: 'Accessibility & Inclusivity',
    body: 'We strive to make lending accessible to everyone, breaking down barriers to financial opportunities. Our marketplace is designed to be inclusive, ensuring that diverse communities have equal access to financial solutions.',
  },
  {
    title: 'Growth Mindset',
    body: 'We foster a culture of learning, adaptability, and resilience. Every challenge is an opportunity to grow, and we continuously seek ways to improve our platform, processes, and impact.',
  },
  {
    title: 'Leading with Humility',
    body: 'We listen, learn, and evolve with our customers, partners, and team members. By staying humble and open to feedback, we create a collaborative ecosystem that benefits all stakeholders.',
  },
];

export const CAREER_INTERVIEW_HEADER = 'Our Interview Process';
export const CAREER_INTERVIEW_SUBHEADER = `From application to offer, we’ll guide you through every step so you know exactly what to
          expect`;

export const CAREER_INTERVIEW_SECTION_LIST = [
  {
    title: '1. Application Review',
    subheader: 'We will review your application and get back to you as soon as possible',
  },
  {
    title: '2. Founder Video Call',
    subheader: 'Meet and go over any questions you may have with the founder',
  },
  {
    title: '3. Technical Interview',
    subheader: "A quick assignment or technical assessment to see how you'd like working with us",
  },
  {
    title: '4. Final Round Interview',
    subheader: 'Speak with multiple members of the team and see how you enjoy working with us',
  },
];

export const JOB_POSTINGS = [
  {
    title: 'Lead Backend Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          The Founding Lead Backend Engineer will be responsible for designing, building, and
          scaling backend services that power CashClever's consumer-facing platform.
        </div>
        <div style={{ marginTop: '5px' }}>Key day-to-day responsibilities: </div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Architecting APIs</li>
          <li>Integrating with third-party financial institutions</li>
          <li>Optimizing performance and reliability</li>
          <li>Ensuring data security and compliance</li>
        </ul>

        <div>
          As an early technical leader, The Lead Backend Engineer will help define the technology
          roadmap and contribute to overall product strategy focused on delivering transparent,
          high-impact financial tools to consumers.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxhfo',
  },
  {
    title: 'Senior Front-End Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          As a Senior Front-End Engineer, you will design, build, and optimize user-facing features
          for CashClever’s web platform, with a primary focus on intuitive, high-performing
          experiences that help consumers compare and choose financial products confidently.
        </div>
        <div style={{ marginTop: '5px' }}>Daily responsibilities include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Writing production-quality code</li>
          <li>Reviewing code from peers</li>
          <li>Refining UI/UX based on user feedback and data</li>
          <li>Contributing to technical architecture and front-end best practices</li>
        </ul>

        <div>
          The Senior Front-End Engineer will help shape the engineering culture by mentoring
          teammates, establishing standards, and participating in roadmap planning.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxhn4',
  },
  {
    title: 'Senior Backend Engineer',
    team: 'Financial Infrastructure',
    description: () => (
      <div>
        <div>
          The Senior Backend Engineer will design, build, and optimize backend services and APIs
          that power CashClever’s lending comparison platform and financial infrastructure.
        </div>
        <div style={{ marginTop: '5px' }}>Responsibilities include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Developing secure, scalable services for rate comparison and transaction flows</li>
          <li>Integrating with external financial institution APIs</li>
          <li>Improving system reliability and performance</li>
        </ul>
        <div>
          The Senior Backend Engineer will collaborate with product managers, data teams, and
          frontend engineers to deliver features end-to-end, maintain code quality and contribute to
          architectural decisions and technical roadmap. As well as enhance security, data privacy
          and compliance across backend systems and support production operations through monitoring
          and troubleshooting.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxhtz',
  },
  {
    title: 'Senior Full Stack Engineer',
    team: 'Consumer',
    description: () => (
      <div>
        <div>
          The Senior Full Stack Engineer will be responsible for designing, developing, and
          maintaining consumer-facing web applications that power CashClever’s lending comparison
          platform.
        </div>
        <div style={{ marginTop: '5px' }}>Day-to-day tasks include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Building and optimizing front-end user interfaces</li>
          <li>Implementing and maintaining back-end services and API</li>
          <li>Ensuring application performance and reliability</li>
          <li>
            Collaborating closely with product, design, and data teams to deliver new features
          </li>
        </ul>

        <div>
          The Senior Full Stack Engineer will also contribute to architectural decisions, code
          reviews, testing strategies, and continuous improvement of development practices to
          support a secure, scalable, and user-centric platform.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxhtg',
  },
  {
    title: 'Product UI / UX Designer',
    team: 'Consumer',
    description: () => (
      <div>
        <div>
          The Product UI / UX Designer will lead end-to-end product design for CashClever’s
          consumer-facing web and mobile experiences.
        </div>
        <div style={{ marginTop: '5px' }}>Key day-to-day activities include:</div>

        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Defining design systems</li>
          <li>Creating and maintaining component libraries</li>
          <li>Documenting design decisions</li>
          <li>Ensuring a cohesive experience across all touchpoints</li>
        </ul>

        <div>
          As a founding design team member, you will contribute to product strategy, help set design
          standards, and play a key part in shaping the future of CashClever’s consumer platform.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxhv1',
  },
  {
    title: 'QA Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          The QA Engineer will ensure the quality and reliability of CashClever’s consumer-facing
          web and mobile applications.
        </div>
        <div style={{ marginTop: '5px' }}>Day-to-day responsibilities include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Designing and executing manual test cases</li>
          <li>Performing functional, regression, and exploratory testing</li>
          <li>Validating new features and enhancements before release</li>
        </ul>
        <div>
          The QA Engineer will document defects, track issues through resolution, and contribute to
          continuous improvement of QA processes and test coverage. The QA Engineer will also
          monitor production behavior, support release activities, and help maintain a consistent,
          high-quality experience for all users.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2Cxinz',
  },
  {
    title: 'Senior QA Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          The Senior QA Engineer is responsible for ensuring the quality and reliability of
          consumer-facing features across CashClever’s platform.
        </div>
        <div style={{ marginTop: '5px' }}>Day-to-day tasks:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Designing, executing, and maintaining test cases</li>
          <li>Performing manual testing of new and existing functionality</li>
          <li>
            Collaborating with product, design, and engineering teams to identify and resolve
            defects
          </li>
        </ul>
        <div>
          As a Senior QA Engineer, you will be a key contributor to test strategy, support release
          processes, and continuously improve QA workflows to enhance user experience.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2CxiAK',
  },
  {
    title: 'Quality Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          The Quality Engineer is responsible for ensuring the reliability, usability, and overall
          quality of CashClever’s consumer-facing products and features.
        </div>
        <div style={{ marginTop: '5px' }}>Day-to-day tasks include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Designing and executing test plans</li>
          <li>Monitoring product performance</li>
          <li>Identifying defects</li>
          <li>
            Collaborating with product, engineering, and customer experience teams to resolve issues
          </li>
        </ul>
        <div>
          The Quality Engineer will develop quality standards, implement automated and manual
          testing strategies, and analyze user feedback to drive continuous improvement in the
          consumer journey. As a Quality Engineer, you will play a key part in maintaining a
          seamless, trustworthy experience across the CashClever platforms.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2CxiAt',
  },
  {
    title: 'Senior Quality Engineer',
    team: 'Consumer Experience',
    description: () => (
      <div>
        <div>
          The Senior Quality Engineer is responsible for designing and executing quality standards
          and testing strategies that ensure a seamless and reliable experience across CashClever’s
          consumer-facing products.
        </div>
        <div style={{ marginTop: '5px' }}>Day-to-day tasks include:</div>
        <ul style={{ marginTop: '5px', marginBottom: '5px' }}>
          <li>Developing test plans</li>
          <li>Performing functional and regression testing</li>
          <li>Monitoring product performance</li>
          <li>
            Collaborating closely with product, engineering, and customer experience teams to
            identify and resolve issues
          </li>
        </ul>
        <div>
          The Senior Quality Engineer will analyze quality metrics, implement continuous improvement
          initiatives, and advocate for best practices in user experience and product reliability.
          The engineer will also be involved in mentoring team members and contributing to the
          evolution of CashClever’s quality engineering processes and tools.
        </div>
      </div>
    ),
    learnMore: 'https://wellfound.com/l/2CxiAW',
  },
];

export const CAREER_OVERVIEW_HEADER = 'Grow Your Career at CashClever';
export const CAREER_OVERVIEW_SUBHEADER =
  'Join our diverse team on a mission to simplify borrowing and help consumers find the best rates';
export const CAREER_OVERVIEW_LIST = [
  {
    number: 'Health, Dental & Vision',
    text: 'Comprehensive insurance coverage for you and your dependents',
  },
  {
    number: 'Remote-Friendly Policy',
    text: 'Options and flexibilies to work remote with teams across different time zones',
  },
  {
    number: 'Diversity & Inclusion',
    text: 'Active ERGs, bias-reduction training, and equity-focused initiatives',
  },
];

export const CAREER_OVERVIEW_IMAGE_ALT = 'A group of team members collaborating around a table';

// Hero section copy
export const HERO_HEADER = 'Join us to Empower Consumers with the Best Financial Decisions';
// export const HERO_SUBHEADER =
//   "By putting money back in the hands of consumers, we don't just create individual wealth but also a stronger economy.";
export const HERO_SUBHEADER =
  'Help us put money back to the hands of the consumers to create more individual wealth and a stronger economy';
export const HERO_CTA_TEXT = 'Open Positions';
export const HERO_CTA_LINK = '#contact-us-career-container';

export const CASHCLEVER_GOOGLE_MAP_URL =
  'https://www.google.com/maps/place/2+University+Plaza+Dr,+Hackensack,+NJ+07601/@40.897875,-74.0369436,16z/data=!3m1!4b1!4m6!3m5!1s0x89c2fa0b9fff2f15:0x2ce6b7c736c24471!8m2!3d40.897871!4d-74.0343687!16s%2Fg%2F11c3q37zlp?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D';

export const HERO_IMAGE_ALT = 'Illustration of team collaborating in an office';
export const TRUSTED_TEXT = "Trusted by the world's best teams";
// Logos for infinite-scrolling “trusted by” banner
export const TRUSTED_LOGOS = [
  { src: '/logos/amazon.svg', alt: 'Amazon' },
  { src: '/logos/dribbble.svg', alt: 'Dribbble' },
  { src: '/logos/hubspot.svg', alt: 'HubSpot' },
  { src: '/logos/notion.svg', alt: 'Notion' },
  { src: '/logos/netflix.svg', alt: 'Netflix' },
  { src: '/logos/zoom.svg', alt: 'Zoom' },
];
